import React from 'react';

import { LEGAL_DOCUMENTS } from '../content/legalDocuments';
import LegalDocumentPage from './LegalDocumentPage';

export default function PrivacyPolicyPage() {
    const { title, pdf } = LEGAL_DOCUMENTS.privacyPolicy;
    return <LegalDocumentPage title={title} pdf={pdf} />;
}
